import {
  Component,
} from "react";
import store from "CommonState/store";
import uiconfig from "CommonState/uiconfig";
import {
  getPathComponent,
} from "CommonCore/location-util";
import {
  withLocation,
} from "CommonCore/router-util";
import PersonKomplettTab from "App/person-komplett-tab";
import AntragPersonTab from "App/antrag-person-tab";
import {
  Panel,
} from "CommonComponents/bricks";
import {
  ANTRAGSTATUS,
} from "App/constants";
import apifetch from "CommonCore/apifetch";

@withLocation
@uiconfig
@store("user")
export default class AntragVerwaltenAntragstellerTab extends Component {
  constructor() {
    super();
    this.state = {};
  }

  fetch = async a_id => {
    const antrag = await apifetch(`/api/shkantrag/antrag/${ a_id }`);
    this.setState({ antrag: antrag.data[0] });
  };

  componentDidMount = () => {
    const a_id = getPathComponent(this.props.location, 2);
    this.fetch(a_id);
  };

  render() {
    const { antrag } = this.state;

    if (!antrag) {
      return null;
    }

    const eingereicht = [ANTRAGSTATUS.STATUS_NEU].indexOf(antrag.a_asid) < 0;

    return <div>
      { !eingereicht &&
          <span>
            <Panel className='box-panel'>Folgende Daten werden mit dem Antrag zusammen eingereicht. Bitte prüfen Sie alle Daten vor dem Einreichen.</Panel>
            <PersonKomplettTab antrag={ antrag } />
          </span> }
      { eingereicht &&
          <span>
            <Panel className='box-panel'>Folgende Daten wurden mit dem Antrag zusammen eingereicht.</Panel>
            <AntragPersonTab antrag={ antrag.a_id } />
          </span>
      }
    </div>;
  }
}
